import React from "react";
import classNames from "classnames";

const roles = [
  { label: "DPS", value: "dps" },
  { label: "Tank", value: "tank" },
  { label: "Heal", value: "heal" },
];

const RoleFilter = (props) => {
  const { onChange, selected } = props;

  return (
    <div className="role-filter-container">
      {(roles ?? []).map(({ label, value }, i) => {
        return (
          <div
            key={i}
            className={classNames("role-filter", {
              active: selected === value,
            })}
            onClick={() => onChange(value)}
          >
            <img src={`https://static.bigbrain.gg/wow/icons/Icon-${label}.png`} />
            <span>{label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default RoleFilter;
